<page-heading
  [title]="'agents.home.title' | translate"
  [description]="'agents.home.description' | translate"
/>

@if (loadingContent) {
<content-loading-list></content-loading-list>
}

<div class="row g-3 mb-0">
  @for (card of cards; track $index) {
    @if (card.visible()) {
      <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
        <div class="card-button-hover h-100 shadow-sm">
          <div class="card h-100" [routerLink]="card.route" style="cursor: pointer">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-center mb-3">
                <div
                  class="img-fluid avatar-md rounded bg-info-subtle d-flex align-items-center justify-content-center"
                >
                  <i
                    class="{{ card.icon }} text-primary fs-1"
                  ></i>
                </div>
              </div>
              <div class="text-center">
                <h4 class="card-title text-dark fw-bold">{{ card.title }}</h4>
                <small class="card-text text-muted fw-semibold">
                  {{ card.subtitle }}
                </small>
                <p class="card-text mt-2 text-muted fw-semibold font-14">
                  {{ card.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
